<script setup>
import { getI18n } from '@/plugins/i18n'
import { usePrintTemplates } from '@/composables/print-template'

import PrintTemplateThumbnail from '@/components/accounting/PrintTemplateThumbnail.vue'

defineProps({
  template: {
    type: Object,
    required: true,
  },
  documentType: {
    type: Number,
    required: true,
  },
})

const i18n = getI18n()
const { isDefaultFor, layoutDescription } = usePrintTemplates()
</script>
<template>
  <q-item-section avatar>
    <print-template-thumbnail class="print-template-item-thumbnail" :template="template" :document-type="documentType" />
  </q-item-section>
  <q-item-section>
    <q-item-label class="row items-center q-gutter-x-xs">
      <span>{{ template.name }}</span>
      <q-chip
        v-if="isDefaultFor(template, documentType)"
        dense
        size="sm"
        color="primary"
        text-color="white"
        icon="mdi-star"
        :label="i18n.t('common.default')"
      />
      <q-chip
        v-if="!template.is_available"
        dense
        size="sm"
        color="warning"
        text-color="white"
        icon="mdi-eye-off-outline"
        :label="i18n.t('common.hidden')"
      />
    </q-item-label>
    <q-item-label caption lines="2">
      {{ layoutDescription(template) }}
    </q-item-label>
  </q-item-section>
</template>
<style scoped>
.print-template-item-thumbnail {
  width: 3.25rem;
}
</style>
